import React from 'react';
import styles from './styles';

export const RBHBox = (props: any) => {
  return (
    <div {...props} style={{ ...styles.boxDefault, ...props.style }}>
    </div>
  );
};

export default RBHBox;
